import { Component, OnInit, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { ValidationService } from '../../shared/services/validation.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-scan-another',
  templateUrl: './scan-another.component.html',
  styleUrls: ['./scan-another.component.scss']
})
export class ScanAnotherComponent implements OnInit {
  showSpinner: boolean = false;
  fullString: string = '';
  previous: string = null;
  scanComplete: boolean = false;

  showError: boolean = false;

  constructor (
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private validate: ValidationService,
    private idle: Idle,
    private router: Router ) {
    }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ( event.which !== 13 && 
      event.which !== 40 &&
      event.key !== 'Shift' ) {
      this.fullString += event.key;
      this.previous = event.key;
    }

    if ( event.which === 13 ) {
      this.showSpinner = true;
      this.scanComplete = true;
      this.processScan(this.fullString);
    }
  }

  //processScan (scan) {
  //  this.showSpinner = true;
  //  let ticket = this.cleanScan(scan);
  //  let validTicket = this.decoder.decode(ticket);
  //  let card = this.dataSvc.currentClubCard;
  //
  //  if( validTicket['status'] === 'OK' && validTicket['code'].length === 40 && card !== '' ) {
  //    this.dataSvc.currentTicket = validTicket;
  //    this.validate.checkClubCard(card)
  //    .then((results) => {
  //      if(results.status === "257") {
  //        this.router.navigate(['/addprofile']);
  //      } else {
  //        if(this.dataSvc.currentTicket !== '') {
  //          this.dataSvc.currentEmail = results.email;
  //          this.AssignTicket();
  //        }
  //      }
  //    })
  //  } else {
  //    // show ticket error
  //    this.router.navigate(['/invalid']);
  //  }
  //}

  processScan (scan) {
    let ticket = this.cleanScan(scan);
    let validTicket = this.decoder.decode(ticket);

    if( validTicket['status'] === 'OK' ) {
      if (validTicket['code'].length === 12) {
        this.dataSvc.currentClubCard = validTicket['code'];
      } else {
        this.dataSvc.currentTicket = validTicket;
      }

      if(!this.dataSvc.currentEmail) {
        this.router.navigate(['/enterid']);
      } else if (this.dataSvc.currentTicket) {
        this.AssignTicket();
      } else {
        this.router.navigate(['/success']);
      }
    } else {
      this.showSpinner = false;
      this.router.navigate(['/invalid']);
    }
  }

  AssignTicket() {
    let ticket = {
      email: this.dataSvc.currentEmail,
      code: this.dataSvc.currentTicket.code
    }
    this.validate.assignTicketAccount(ticket)
    .then((results) => {

      if(results.status === "204") {
        this.dataSvc.redeemValue = results.value;
        this.router.navigate(['/success']);
      }

      if(results.status === "409") {
        this.dataSvc.errorMessage = results.message;
        this.router.navigate(['/invalid']);
      }
    })    
  }

  cleanScan(scan) {
    scan = scan.substr(scan.lastIndexOf('/') + 1);
    let ticket = scan.split('-').join('');
    return ticket;
  }

  ngOnInit() {
    this.dataSvc.currentTicket = null;
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/scan-another/scan-another.component.ts